(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('step1', {
                parent: 'store',
                url: '/step1',
                data: {
                    authorities: ['ROLE_STORE'],
                    pageTitle: 'global.menu.entities.store'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/initialization/init-step1.html',
                        controller: 'InitStepOneController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('storeType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('guide-commodity', {
                parent: 'app',
                url: '/guide-commodity',
                data: {
                    authorities: ["ROLE_PRODUCT"],
                    pageTitle: 'backApp.productPurchase.home.title'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/initialization/commodity.html',
                        controller: 'GideCommodityController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productPurchase');
                        $translatePartialLoader.addPart('purchaseStatus');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
